import { useCallback, useState } from "react";
import { PrevisaoOrcamentariaParams } from "core/features/previsao-orcamentaria/typings/index";

export const defaultFiltroPrevisaoOrcamentaria = {
  search: "",
  orderBy: "dataInicio",
  orderDirection: "DESC",
};

function useFiltroPrevisaoOrcamentaria() {
  const [filtro, setFiltro] = useState<PrevisaoOrcamentariaParams>(
    defaultFiltroPrevisaoOrcamentaria
  );

  const onChangeFiltro = useCallback(
    (newValues: Partial<PrevisaoOrcamentariaParams>) => {
      setFiltro((prev: any) => ({ ...prev, ...newValues }));
    },
    []
  );

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultFiltroPrevisaoOrcamentaria);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroPrevisaoOrcamentaria;
